import { combineReducers } from "@reduxjs/toolkit";
import queryTextReducer from "./querySlice";
import feedReducer from "./feedSlice";
import historyReducer from "./historySlice";
import activeChatReducer from "./threadSlice";
import activityReducer from "./activitySlice";
import dateRangeReducer from "./dateRangeSlice";
import promptReducer from "./promptSlice";
import tokenReduer from "./tokenSlice";
import webSocketReducer from "./webSocketSlice";
import keysegmentsAndStorylinesReducer from "./keysegmentsAndStorylinesSlice";

export default combineReducers({
  queryText: queryTextReducer,
  feed: feedReducer,
  historicalChatID: historyReducer,
  activeChatID: activeChatReducer,
  activity: activityReducer,
  dateRange: dateRangeReducer,
  prompts: promptReducer,
  token: tokenReduer,
  keysegmentsAndStorylines: keysegmentsAndStorylinesReducer,
  webSocket: webSocketReducer,
});
